export default [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    customRender: (value, item, index) => {
      return index + 1
    },
  },
  {
    title: '用户名',
    dataIndex: 'username',

  },
  {
    title: '员工姓名',
    dataIndex: 'name',

  },
  {
    title: '手机号',
    dataIndex: 'phone',
  },
  {
    title: "状态",
    dataIndex: "is_active",
    key: "is_active",
    scopedSlots: { customRender: "is_active" },
  },
  {
    title: "管理员",
    dataIndex: "is_admin",
    key: "is_admin",
    scopedSlots: { customRender: "is_admin" },
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    width: '256px'
  },
]